import {useEffect, useMemo, useState, useRef} from "react";

/**
 * @param path: string
 * @returns {{data: string, loading: boolean}}
 */
const useFetchAuthImage = ({ path }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  // Use a ref to track the current objectUrl without triggering re-renders
  const objectUrlRef = useRef(null);

  const url = useMemo(() => window.localStorage.getItem("BaseURL") + path, [path]);

  useEffect(() => {
    const fetchImage = async () => {
      setLoading(true)
      try {
        const response = await fetch(url, {
          headers: {
            'Authorization': "Bearer " + window.localStorage.getItem("Token")
          }
        });

        if (response.ok) {
          const blob = await response.blob();
          // Clean up previous objectUrl if it exists
          if (objectUrlRef.current) {
            URL.revokeObjectURL(objectUrlRef.current);
          }
          // Create new objectUrl and store it in the ref
          const newObjectUrl = URL.createObjectURL(blob);
          objectUrlRef.current = newObjectUrl;
          setData(newObjectUrl);
        }
      } catch (error) {
        console.error("Failed to fetch image:", error);
      } finally {
        setLoading(false);
      }
    };

    if (path) {
      fetchImage();
    } else {
      setData(null);
      setLoading(false);
    }

    // Cleanup function
    return () => {
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
    };
  }, [path, url]); // url is the only dependency

  return {data, loading}
};

export default useFetchAuthImage;
